/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { SnackbarProvider } from 'notistack';
import useStyle from './useStyle';
import { Toaster, CustomTable, CustomSwitch } from '../../../../components';
import COLUMNS from './constants';
import { getPaymentLinksRows } from './utils';

const PaymentLinksTable = (props) => {
  const classes = useStyle();
  const {
    paymentLinks,
    totalElementsData,
    onNext,
    onSelectPageSize,
    searchQuery,
    loading,
  } = props;
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const providerRef = React.useRef();
  const [paymentLinksRows, setPaymentLinksRows] = React.useState([]);

  function createActions(active, paymentLinkId) {
    return (
      <Box display="flex" flexDirection="row" justifyContent="center">
        <Tooltip
          title="Cambiar estado"
          aria-label="changeState"
          placement="top"
        >
          <Box alignSelf="center">
            <CustomSwitch
              checked={active}
              value={paymentLinkId}
              name="active"
              disabled
            />
          </Box>
        </Tooltip>
        <IconButton
          edge="end"
          aria-label="Editar"
          size="small"
          classes={{ disabled: classes.disabled }}
          disabled
        >
          <Tooltip title="Editar" aria-label="edit" placement="top">
            <EditIcon className={classes.editIcon} />
          </Tooltip>
        </IconButton>
      </Box>
    );
  }

  useEffect(() => {
    setPaymentLinksRows([]);
    getPaymentLinksRows(paymentLinks, createActions, setPaymentLinksRows);
  }, [paymentLinks]);

  return (
    <SnackbarProvider ref={providerRef}>
      <CustomTable
        data={paymentLinksRows}
        columns={COLUMNS}
        totalElementsData={totalElementsData}
        onNext={onNext}
        onSelectPageSize={onSelectPageSize}
        searchQuery={searchQuery}
        loading={loading}
        readOnly
      />

      <Toaster
        show={alert.status}
        type={alert.type}
        text={alert.message}
        onClose={() => setAlert({ ...alert, status: false })}
      />
    </SnackbarProvider>
  );
};

export default PaymentLinksTable;
